import { useEffect, useState } from 'react';
import { officeReady } from '@/services/office/officeReady';
import { isComposeItem } from '@/services/office/composeContext';
import { useSendAndFileFlagMirror } from '@/features/send-and-file/useSendAndFileFlagMirror';
import { TaskPaneShell } from './TaskPaneShell';
import { SendAndFileView } from '@/features/send-and-file/SendAndFileView';

/**
 * Le volet est-il attaché à un message en cours de RÉDACTION ?
 *
 * ON NE BLOQUE PAS LE RENDU EN ATTENDANT OFFICE, et c'est le point important.
 * `officeReady()` n'a aucun délai de garde : si `Office.onReady` est lent ou ne se
 * déclenche jamais — le cas d'un volet épinglé après un rafraîchissement — une
 * attente laisserait le volet DÉFINITIVEMENT BLANC. C'est le défaut que
 * `OfficeProvider` documente pour l'avoir subi ; il ne sera pas réintroduit ici.
 *
 * D'où cette forme : on répond tout de suite avec ce qu'on peut savoir, puis on
 * corrige une fois Office prêt. Le passage se fait dans UN SEUL SENS — un message
 * en rédaction ne devient jamais un message en lecture — donc la vue ne peut pas
 * osciller.
 */
function useIsCompose(): boolean {
  const [compose, setCompose] = useState(() => isComposeItem());

  useEffect(() => {
    if (compose) return;
    let alive = true;
    void officeReady()
      .then(() => {
        if (alive && isComposeItem()) setCompose(true);
      })
      .catch(() => {
        // Sans Office, on reste sur le volet habituel : utilisable, plutôt que
        // rien.
      });
    return () => {
      alive = false;
    };
  }, [compose]);

  return compose;
}

export function PaneRouter() {
  // Monté ici, donc dans les DEUX modes : la préférence doit être recopiée pour le
  // gestionnaire d'événement même quand l'utilisateur n'ouvre le volet que depuis
  // sa boîte de réception — c'est même le cas le plus courant.
  useSendAndFileFlagMirror();
  const compose = useIsCompose();

  return compose ? <SendAndFileView /> : <TaskPaneShell />;
}
